<div class="modulo modulo-eventos" *ngIf="data.eventos.length > 0">
    <div class="modulo-titulo" *ngIf="data.mostrar_titulo">
        <div class="container">
            <h2>{{data.titulo}}</h2>
        </div>
    </div>
    <div class="modulo-content">
        <div class="container">
            <div class="row">
                <div class="col-md-3" *ngFor="let e of data.eventos">
                    <evento-item template="home" [data]="e"></evento-item> 
                </div>   
            </div>
            <div class="linha"></div>
            <div class="content-button">
                <a routerLink="/agenda" title="Agenda Completa">
                    <span>Ver todos</span>
                </a>    
            </div>    
        </div>   
    </div>    
</div>